import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  flexDirection: 'column'
});

export const TabsContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 99
}));

export const HomeIconContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',

  '&:hover': {
    '& path': {
      fill: `${theme.palette.primary.main} !important`
    }
  }
}));
